import { useEffect, useState } from 'react';

const showBadge = () => {
  if (!window.grecaptcha) {
    return;
  }

  window.grecaptcha.ready(() => {
    const badge = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;

    if (!badge) {
      return;
    }

    badge.style.display = 'block';
    badge.style.zIndex = '1';
  });
};

const hideBadge = () => {
  if (!window.grecaptcha) {
    return;
  }

  window.grecaptcha.ready(() => {
    const badge = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;

    if (!badge) {
      return;
    }

    badge.style.display = 'none';
  });
};

const RECAPTCHA_WAITING = 0;
const RECAPTCHA_LOADING = 1;
const RECAPTCHA_LOADED = 2;

const useRecaptcha = (): {
  loading: boolean;
  loaded: boolean;
  generateToken: (action: string) => Promise<string>;
} => {
  const [state, setState] = useState(RECAPTCHA_WAITING);

  const loadRecaptcha = () => {
    if (typeof window === 'undefined') {
      return false;
    }

    if (window.grecaptcha) {
      showBadge();

      if (state !== RECAPTCHA_LOADED) {
        setState(RECAPTCHA_LOADED);
      }

      return true;
    }

    setState(RECAPTCHA_LOADING);

    return new Promise((resolve, reject) => {
      if (!`${import.meta.env.VITE_PUBLIC_ENV__RECAPTCHA_SITE_KEY}`) {
        return reject(new Error('missing RECAPTCHA_SITE_KEY'));
      }

      const timeout = setTimeout(reject, 20000);

      const script = document.createElement('script');

      script.async = true;
      script.src = `https://www.google.com/recaptcha/api.js?render=${
        import.meta.env.VITE_PUBLIC_ENV__RECAPTCHA_SITE_KEY
      }`;
      script.addEventListener('load', () => {
        clearTimeout(timeout);
        setState(RECAPTCHA_LOADED);
        showBadge();
        resolve(true);
      });
      document.body.appendChild(script);
    });
  };

  // Load ReCaptcha script
  //   useEffect(loadRecaptcha, [state]);

  // Hide badge when unmount
  useEffect(() => hideBadge, []);

  // Get token
  const generateToken = async (action: string): Promise<string> => {
    await loadRecaptcha();

    return await new Promise((resolve, _reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(import.meta.env.VITE_PUBLIC_ENV__RECAPTCHA_SITE_KEY, { action })
          .then((token: string) => {
            resolve(token);
          });
      });
    });
  };

  return {
    loading: state === RECAPTCHA_LOADING,
    loaded: state === RECAPTCHA_LOADED,
    generateToken,
  };
};

export default useRecaptcha;
